import React from 'react';

import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import offlineImage from 'src/assets/images/offline.webp';
import { useParkingStatus } from 'src/features/parkingManagement/hooks/useParkingStatus';
import { SectionBlock, SectionBlockSubtitle, SectionBlockTitle } from 'src/registry/components/blocks/SectionBlock.tsx';
import { Button } from 'src/registry/ui/Button.tsx';
import { offlineMessages } from 'src/utils/messages.ts';

const Offline = () => {
    const { refetch, isFetching } = useParkingStatus();
    const [manualFetch, setManualFetch] = React.useState<boolean>(false);

    const handleReconnectButton = async () => {
        setManualFetch(true);
        try {
            await refetch();
        } finally {
            setManualFetch(false);
        }
    };

    return (
        <SectionBlock className="flex flex-1 flex-col items-center justify-center">
            <img src={offlineImage} alt="parking offline" className="h-auto w-44" />
            <SectionBlockTitle>
                <FormattedMessage {...offlineMessages.parkingOffline} />
            </SectionBlockTitle>
            <SectionBlockSubtitle className="-mt-4 text-center">
                <FormattedMessage {...offlineMessages.parkingOfflineDescription} />
            </SectionBlockSubtitle>
            <Button variant="outline" onClick={handleReconnectButton} disabled={isFetching && manualFetch}>
                {isFetching && manualFetch && <FontAwesomeIcon icon={faSpinnerThird} className="mr-2 animate-spin" />}
                <FormattedMessage {...offlineMessages.reconnect} />
            </Button>
        </SectionBlock>
    );
};

export default Offline;
